import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { formatDateString } from "./../../utilities/datesFormatter";
import {
  getTempData,
  getRanges,
  downloadTempXls,
  saveRanges
} from "../../modules/temp";
import { changeSelectedTags } from "../../modules/units";
import { setStartDate, setEndDate } from "../../modules/dates";
import { changeTitle } from "../../modules/navigation";

import TempView from "./TempView";
import hasTP from "../../utilities/unitsFilters";
import { DOMAIN } from "../../utilities/consts";
import { fahrenheitToCelsius, celsiusToFahrenheit } from "../../utilities/temp";

class Temp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenRangeConfiguration: false,
      isAlertMessageOpen: false,
      alertMessage: "",
      ranges: {
        minRange: -30,
        maxRange: 80
      },
      prevRanges: [],
      selectedUnitsRange: [],
      isAllUnitsRangeSelected: false
    };
  }
  componentDidMount() {
    const { changeTitle, getRanges, changeSelectedTags } = this.props;
    changeTitle("Temp");
    changeSelectedTags([]);
    getRanges(this.props.units.map(unit => unit.Unidad));
  }

  handleGetData = () => {
    const { lang } = this.props;
    const config = {
      unidades: this.props.selectedUnits,
      fechaInicial: this.props.startDate._d.getTime(),
      fechaFinal: this.props.endDate._d.getTime(),
      zona: this.props.zone,
      unidadTemperatura: this.props.temperatureUnit,
      unidadMetrica: "km"
    };

    if (config.unidades.length === 0) {
      this.openAlertMessage(lang.SeleccioneAlMenosUnaUnidad);
      return;
    }
    this.props.getTempData(config);
  };

  handleCloseRangeConfigutation = () => {
    this.setState({
      isOpenRangeConfiguration: false
    });
  };

  handleOpenRangeConfiguration = () => {
    this.setState({ isOpenRangeConfiguration: true });
  };

  changeRangeConfiguration = () => {
    let ranges = this.state.ranges;
    const { lang, mostRecentRanges, temperatureUnit } = this.props;

    //Conversion porque en BD se guarda en grados Celsius
    if (temperatureUnit === "F") {
      ranges.LimiteInferior = fahrenheitToCelsius(ranges.LimiteInferior);
      ranges.LimiteSuperior = fahrenheitToCelsius(ranges.LimiteSuperior);
    }

    if (this.state.selectedUnitsRange.length === 0) {
      this.openAlertMessage(lang.SeleccioneAlMenosUnaUnidad);
      return;
    }
    if (ranges.maxRange <= ranges.minRange) {
      this.openAlertMessage(lang.RangoMaximoMayorARangoMinimo);
      return;
    }

    let prevRanges = this.state.selectedUnitsRange.reduce((array, unit) => {
      let ranges = mostRecentRanges.filter(r => r.Unidad === unit);
      if (ranges.length > 0) {
        array.push(ranges[0]);
      }
      return array;
    }, []);

    this.setState({ prevRanges });

    const config = this.state.selectedUnitsRange.map(unit => ({
      Unidad: unit,
      Fecha: null,
      LimiteInferior: ranges.minRange,
      LimiteSuperior: ranges.maxRange
    }));

    this.props
      .saveRanges({ rangos: config })
      .then(() => {
        this.setState({ isOpenRangeConfiguration: false });
        this.openAlertMessage(lang.RangosDeTemperaturaAplicados);
      })
      .catch(() => {
        this.openAlertMessage(lang.ErrorAlAplicarRangos);
      });
  };

  undoChangesConfiguration = () => {
    const prevRanges = this.state.prevRanges;
    const { lang } = this.props;
    if (prevRanges.length > 0) {
      this.props
        .saveRanges({ rangos: prevRanges })
        .then(() => {
          this.setState({ isOpenRangeConfiguration: false });
          this.openAlertMessage(lang.RangosDeTemperaturaRestablecidos);
        })
        .catch(() => {
          this.openAlertMessage(lang.ErrorAlRestablecerRangos);
        });
    }
  };

  onBlurInputConfiguration = e => {
    let value = e.target.value;
    const id = e.target.id;
    let ranges = Object.assign({}, this.state.ranges);

    if (value === "" && id === "minRange") {
      ranges[id] = -30;
    } else if (value === "" && id === "maxRange") {
      ranges[id] = 80;
    }

    value = this.setState({
      ranges: ranges
    });
  };

  handleInputsConfiguration = e => {
    e.preventDefault();
    const id = e.target.id;
    let value = e.target.value;
    let ranges = Object.assign({}, this.state.ranges);

    ranges[id] = value;

    this.setState({
      ranges
    });
  };

  handleSelectUnitsRanges = (selectedUnits, isAllSelected) => {
    this.setState({
      selectedUnitsRange: selectedUnits,
      isAllUnitsRangeSelected: isAllSelected
    });
  };

  openAlertMessage = message => {
    this.setState({
      isAlertMessageOpen: true,
      alertMessage: message
    });
  };

  handleCloseAlertMessage = () => {
    this.setState({
      isAlertMessageOpen: false,
      message: ""
    });
  };

  downloadExcel = () => {
    const fechaInicial = this.props.startDate.valueOf(),
      fechaFinal = this.props.endDate.valueOf(),
      lang = this.props.lang._code === "en" ? "en-US" : "es-MX",
      unidades =
        this.props.reportData.Resultados !== undefined
          ? [this.props.reportData.Resultados[0].Unidad]
          : [],
      unidadDistancia = this.props.distanceUnit,
      unidadTemperatura = this.props.temperatureUnit,
      zona = this.props.zone;

    window.open(
      `${DOMAIN}/GenerarReporte.aspx?sTipoReporte=temperatura&fInicial=${fechaInicial}&fFinal=${fechaFinal}&aUnidades=${unidades}&zona=${zona}&lang=${lang}&unidadDistancia=${unidadDistancia}&unidadTemperatura=${unidadTemperatura}`,
      "_blank"
    );
  };

  downloadPDF = () => {};

  render() {
    return (
      <TempView
        handleGetData={this.handleGetData}
        isOpenRangeConfiguration={this.state.isOpenRangeConfiguration}
        handleCloseRangeConfigutation={this.handleCloseRangeConfigutation}
        handleOpenRangeConfiguration={this.handleOpenRangeConfiguration}
        changeRangeConfiguration={this.changeRangeConfiguration}
        handleInputsConfiguration={this.handleInputsConfiguration}
        downloadExcel={this.downloadExcel}
        downloadPDF={this.downloadPDF}
        ranges={this.state.ranges}
        selectedUnitsRange={this.state.selectedUnitsRange}
        isAllUnitsRangeSelected={this.state.isAllUnitsRangeSelected}
        isAlertMessageOpen={this.state.isAlertMessageOpen}
        alertMessage={this.state.alertMessage}
        handleCloseAlertMessage={this.handleCloseAlertMessage}
        handleSelectUnitsRanges={this.handleSelectUnitsRanges}
        onBlurInputConfiguration={this.onBlurInputConfiguration}
        undoChangesConfiguration={this.undoChangesConfiguration}
        {...this.props}
      />
    );
  }
}

const mapStateToProps = state => {
  let events = [];
  let refrigerationCycles = [];
  let outOfRanges = [];
  let hasData = state.temp.hasData;
  let lang = state.internationalization.lang;
  let unitRanges = [];
  let mostRecentRanges = [];
  let temperatureUnit = state.internationalization.temperatureUnit;
  let temperaturaUnitReport = 0;
  let report = Object.assign({}, state.temp.data);
  const selectedTags = state.units.selectedTags;

  let units = state.units.data
    .filter(v => hasTP(v, [".temp", ".tpv"]))
    .map(unit => {
      let ranges = state.temp.ranges
        .filter(range => range.Unidad === unit.Unidad)
        .sort(sortDateDesc);
      if (ranges[0] !== undefined) mostRecentRanges.push(ranges[0]);

      return {
        ...unit,
        LimiteInferior:
          ranges.length > 0
            ? temperatureUnit === "F"
              ? celsiusToFahrenheit(ranges[0].LimiteInferior)
              : ranges[0].LimiteInferior
            : null,
        LimiteSuperior:
          ranges.length > 0
            ? temperatureUnit === "F"
              ? celsiusToFahrenheit(ranges[0].LimiteSuperior)
              : ranges[0].LimiteSuperior
            : null
      };
    });

  if (selectedTags.length > 0)
    units = units.filter(unit => {
      let unitTags = unit.Etiquetas.split(",").filter(t => t !== "");
      return (
        unitTags.filter(ut => {
          return selectedTags.includes(ut);
        }).length > 0
      );
    });

  if (hasData) {
    temperaturaUnitReport = report.UnidadTemperatura;

    events = report.Resultados[0].EventosTemp.map(e => ({
      ImagenUrl: `https://apps.zeekgps.com/ZeekTemp/images/${e.Evento}.svg`,
      FechaEvento: formatDateString(e.Fecha),
      NombreEvento: lang[`Event${e.Evento}`],
      Latitud: e.Latitud,
      Longitud: e.Longitud
    }));

    refrigerationCycles = report.Resultados[0].CiclosRefrigeracion.map(c => ({
      ...c,
      Inicio: formatDateString(c.Inicio),
      Fin: formatDateString(c.Fin)
    }));

    outOfRanges = report.Resultados[0].IntervalosFueraRango.map(i => ({
      ...i,
      Inicio: formatDateString(i.Inicio),
      Fin: formatDateString(i.Fin),
      UbicacionInicio: report.Resultados[0].Ubicaciones.filter(
        u => u.Fecha === i.Inicio
      )[0],
      UbicacionFin: report.Resultados[0].Ubicaciones.filter(
        u => u.Fecha === i.Fin
      )[0]
    }));

    unitRanges = state.temp.ranges
      .filter(range => report.Resultados[0].Unidad === range.Unidad)
      .sort(sortDateDesc);
  }

  return {
    reportData: report,
    isLoading: state.temp.isLoading,
    hasData,
    lang,
    units,
    selectedUnits: state.units.selectedUnits,
    startDate: state.dates.startDate,
    endDate: state.dates.endDate,
    permissions: state.permissions.data,
    loadedPermissions: state.permissions.loadedPermissions,
    mostRecentRanges,
    hasRanges: state.temp.hasRanges,
    zone: state.dates.zone,
    events,
    refrigerationCycles,
    outOfRanges,
    unitRanges,
    temperatureUnit
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getTempData,
      getRanges,
      saveRanges,
      downloadTempXls,
      setStartDate,
      setEndDate,
      changeTitle,
      changeSelectedTags
    },
    dispatch
  );

const sortDateDesc = (a, b) => {
  let dateA = new Date(a.Fecha);
  let dateB = new Date(b.Fecha);
  if (dateA < dateB) return 1;
  else if (dateA > dateB) return -1;
  return 0;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Temp);



// WEBPACK FOOTER //
// ./src/containers/Temp/Temp.js